<template>
  <div id="category">
    <div class="topbar">
      <div class="title">{{ item.name }}</div>
      <div class="menu">
        <router-link
          :to="'/competition/' + item.id + '/results'"
          class="item"
          :class="{
            selected: page == 1
          }"
          >{{ $t("miclive.competition.results") }}</router-link
        >
        <router-link
          :to="'/competition/' + item.id + '/scoreboard'"
          class="item"
          :class="{ selected: page == 2 }"
          >{{ $t("miclive.competition.scoreboard") }}</router-link
        >
        <router-link
          :to="'/competition/' + item.id + '/playoff'"
          class="item"
          :class="{ selected: page == 3 }"
          >{{ $t("miclive.competition.playoff") }}</router-link
        >

        <router-link
          :to="'/competition/' + item.id + '/ranking'"
          class="item"
          :class="{ selected: page == 4 }"
          >{{ $t("miclive.competition.ranking") }}</router-link
        >
      </div>
    </div>
    <div class="content">
      <template v-if="page == 1 || page == 2">
        <select @change="onChange($event)" id="group_selected">
          <option value="-1">{{
            $t("miclive.competition.all_groups2")
          }}</option>
          <option v-for="group in item.groups" :key="group.id" :value="group.id"
            >{{ $t("miclive.competition.group") }} {{ group.name }}</option
          >
        </select>
      </template>

      <template v-if="page == 1">
        <template v-if="matches">
          <template v-for="(list, date) in matches">
            <div
              class="title"
              :class="{ collapsed: collapse[date] }"
              @click="collapseMatches(date)"
            >
              {{ date }}
            </div>
            <div v-if="!collapse[date]" class="matches">
              <Match
                v-for="match in list"
                :key="match.id"
                :item="match"
              ></Match>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="loader"></div>
        </template>
      </template>

      <template v-if="page == 2">
        <template v-if="scoreboard">
          <template v-if="groupId == -1">
            <!-- <div class="message">
              {{ $t("miclive.competition.select_group") }}
            </div> -->
            <div v-for="group in Object.values(groups)" :key="group.id">
                <div v-if="group.checking" class="alert">
                    {{ $t("miclive.competition.alert") }}
                </div>
                <Standings :key="'standings-' + group.id" :table="group.scoreboard" :name="group.name"></Standings>
            </div>
          </template>
          <template v-else>
            <div v-if="checking" class="alert">
              {{ $t("miclive.competition.alert") }}
            </div>
            <Standings :table="scoreboard"></Standings>
          </template>
        </template>
        <template v-else>
          <div class="loader"></div>
        </template>
      </template>

      <template v-if="page == 3">
        <select @change="changePhase($event)">
          <option
            v-for="phase in item.phases"
            v-if="phase.type != '1'"
            :key="phase.id"
            :value="phase.id"
            >{{ $t(phase.name) }}</option
          >
        </select>
        <template v-if="rounds">
          <template v-for="phase in item.phases" v-if="phase.type == '2'">
            <select @change="changeRound($event)">
              <option
                v-for="round in rounds"
                :key="round.id"
                :value="round.id"
                >{{ $t(round.name) }}</option
              >
            </select>
          </template>
        </template>

        <template v-if="matches">
          <div class="matches">
            <Match
              v-for="match in matches"
              :key="match.id"
              :item="match"
            ></Match>
          </div>
        </template>
        <template v-else>
          <div class="loader"></div>
        </template>
      </template>

      <template v-if="page == 4">
        <template v-if="ranking_type">
          <!-- {{ ranking_team }} -->
          <select @change="changeRanking($event)">
            <option value="player">{{
              $t("miclive.competition.ranking_player")
            }}</option>
            <option value="team">{{
              $t("miclive.competition.ranking_team")
            }}</option>
          </select>
          <Ranking
            v-if="ranking_type == 'team'"
            :table="ranking_team"
          ></Ranking>
          <Ranking
            v-if="ranking_type == 'player'"
            :table="ranking_player"
          ></Ranking>
        </template>
        <template v-else>
          <div class="loader"></div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { Api } from "@/core/api.js";

import Match from "@/components/domain/competition/match";
import Standings from "@/components/domain/categories/Standings";
import Ranking from "@/components/domain/categories/Ranking";
const api = new Api();

export default {
  name: "Category",
  props: {
    item: Object
  },
  components: { Match, Standings, Ranking },
  data() {
    return {
      matches: false,
      scoreboard: {},
      ranking_type: "player",
      ranking_team: false,
      ranking_player: false,
      groupId: -1,
      roundId: false,
      phaseId: false,
      rounds: false,
      checking: false,
      collapse: {},
      groups: []
    };
  },
  computed: {
    route() {
      return this.$route.name;
    },
    page() {
      var value = 1;
      switch (this.route) {
        case "competition_category_results":
        case "competition_category":
          value = 1;
          break;
        case "competition_category_scoreboard":
          value = 2;
          break;
        case "competition_category_playoff":
          value = 3;
          break;
        case "competition_category_ranking":
          value = 4;
          if (this.ranking_type == "team") {
            this.loadRankingTeam();
          } else {
            this.loadRankingPlayer();
          }
          break;
      }

      return value;
    }
  },
  methods: {
    changeRanking(event) {
      this.ranking_type = event.target.value;
      this.loadPhase();
    },
    onChange(event) {
      this.groupId = event.target.value;
      this.loadGroup(event.target.value);
    },
    changePhase(event) {
      this.phaseId = event.target.value;
      this.rounds = this.item.phases[this.phaseId].rounds;
      this.roundId = Object.keys(this.rounds)[0];
      this.loadPhase(event.target.value);
    },
    changeRound(event) {
      this.roundId = event.target.value;
      this.loadPhase();
    },
    collapseMatches(date) {
      this.collapse[date] = !this.collapse[date];
    },
    loadRankingTeam() {
      if (!this.ranking_team) {
        var self = this;

        var params = {
          category_id: this.item.id,
          type: "team"
        };

        api.post("miclive/ranking", params).then(function(data) {
          self.ranking_team = data.data;
        });
      }
    },
    loadRankingPlayer() {
      if (!this.ranking_player) {
        var self = this;

        var params = {
          category_id: this.item.id,
          type: "player"
        };

        api.post("miclive/ranking", params).then(function(data) {
          self.ranking_player = data.data;
        });
      }
    },
    loadGroup(groupId) {
      var self = this;

      if (groupId) {
        var params = {
          category_id: this.item.id,
          group_id: groupId
        };
        if (this.page == 1) {
          this.matches = false;
          api.post("miclive/matches", params).then(function(data) {
            // self.matches = data.data;
            self.matches = self.formatMatches(data.data);
          });
        } else if (this.page == 2) {
          this.scoreboard = {};
          this.checking = false;

          console.log(params);

          api.post("miclive/scoreboard", params).then(function(data) {
            if(data.data.groups){
                self.groups = data.data.groups;
            } else {
                self.scoreboard = data.data.scoreboard;
                self.checking = data.data.checking == 1;
            }
          });
        }
      }
    },
    loadPhase() {
      var self = this;

      //   console.log(this.item);
      //       if (this.item.phases) {
      //         this.phaseId = Object.keys(this.item.phases)[1];
      //         console.log(this.phaseId);
      //         console.log(this.item.phases);
      //         this.rounds = this.item.phases[this.phaseId].rounds;
      //         this.roundId = Object.keys(this.rounds)[0];
      //         console.log("loadPhase 1");
      //         this.loadPhase();
      //       }

      if (!this.phaseId) {
        this.phaseId = Object.keys(this.item.phases)[1];
      }

      if (!this.roundId) {
        this.rounds = this.item.phases[this.phaseId].rounds;
        this.roundId = Object.keys(this.rounds)[0];
      }

      if (this.phaseId && this.roundId) {
        var params = {
          phase_id: this.phaseId,
          round_id: this.roundId
        };

        self.matches = false;

        api.post("miclive/matches", params).then(function(data) {
          self.matches = data.data;
        });
      }
    },
    formatMatches(matches) {
      var result = {};
      var collapse = {};
      for (var i in matches) {
        var match = matches[i];
        var key = moment(match.date, "YYYY-MM-DD HH:mm").format("dddd DD/MM");
        if (!result[key]) result[key] = [];
        result[key].push(match);

        collapse[key] = moment(key, "dddd DD/MM").isBefore(moment(), "day");
      }

      for (var i in result) {
        result[i].sort(function(a, b) {
          var playing_a = a.status >= 3 && a.status <= 8 ? 1 : 0;
          var playing_b = b.status >= 3 && b.status <= 8 ? 1 : 0;

          var finish_a = a.status >= 8 ? 1 : 0;
          var finish_b = b.status >= 8 ? 1 : 0;

          return (
            playing_b - playing_a ||
            finish_a - finish_b ||
            moment(a.date).unix() - moment(b.date).unix()
          );
        });
      }

      this.collapse = collapse;

      return result;
    }
  },
  mounted() {
    if (this.page == 1) {
      var group = Object.values(this.item.groups)[0];
      //   this.groupId = group.id;
    }
    // this.loadGroup(this.groupId);
  },
  watch: {
    "$route.params": {
      handler: function(newValue, value) {
        console.log("change page", this.page);
        if (this.page == 1 || this.page == 2) {
          this.loadGroup(this.groupId);
        } else if (this.page == 3) {
          this.loadPhase();
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
#category {
  padding-top: 70px;
  .topbar {
    background-color: $secondary-color;
    height: 65px;
    padding: 10px 10px;
    width: 100%;
    position: fixed;
    top: 60px;
    left: 0;
    z-index: 10;

    box-shadow: 0 4px 3px rgba(0, 0, 0, 0.2);
    text-align: center;

    .title {
      text-align: center;
      width: 100%;
      font-size: 20px;
      margin-bottom: 5px;
    }

    .menu {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      .item {
        text-transform: uppercase;
        font-size: 11px;
        padding: 0 5px;
        text-decoration: none;
        color: #222;

        &.selected {
          font-family: $font-title;
        }
      }
    }
  }

  .content {
    .message {
      padding: 12px 0;
      text-align: center;
    }
    .alert {
      background: #edd98f;
      font-size: 14px;
      padding: 15px;
      border-radius: 4px;
      margin: 20px 0;
    }
    select {
      width: 100%;
      padding: 15px 10px;
      margin-bottom: 10px;
      border: none;
      outline: none;
      border-radius: 4px;
      background: #fff;
    }

    .title {
      margin: 25px 0 20px 0;
      position: relative;
      cursor: pointer;

      &:after {
        content: " ";
        width: 25px;
        height: 25px;
        background-color: #ccc;
        display: inline-block;
        position: absolute;
        right: 0;
        border-radius: 4px;
        cursor: pointer;
        background: url("~@/../public/img/down.svg") no-repeat center center
          #ddd;
        background-size: 15px;
        transform: rotate(180deg);
      }

      &.collapsed {
        &:after {
          transform: rotate(0deg);
        }
      }
    }

    .matches {
      display: grid;
      grid-gap: 10px;
      grid-template-columns: minmax(0, 1fr);
    }
  }
}

.tablet {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.laptop {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.desktop {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
</style>
